var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.wrapper},_vm._l((_vm.steps),function(step,index){
var _obj;
return _c('li',{key:index,class:[_vm.$style.item, ( _obj = {}, _obj[_vm.$style.active] = _vm.isActive(step), _obj )]},[_vm._v("\n    "+_vm._s(_vm.capitalize(step))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }